export type { BankTransferVariant } from "./bankTransfer.variants"
export { bankTransferVariants } from "./bankTransfer.variants"

